import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {StorageService} from '../../_services/storage.service'
import {HttpEventType} from '@angular/common/http';
import {getStorageImageUrl, normalizeStorageImagePath} from '../../_helpers/storage-image';
import {ImagePreviewComponent} from '../image-preview/image-preview.component';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnChanges {
  @Input() orgId = -1;
  @Input() selectedFile: string | null;
  @Output() selectedFileChange = new EventEmitter<string | null>();
  @Output() uploadSuccess = new EventEmitter<string>();
  @Output() uploadError = new EventEmitter<any>();
  @Input() defaultImage = 'assets/default-image.png';
  @Input() enablePreview = false;
  @Input() imageDescription = 'Immagine caricata';
  uploading = false;
  progress = 0;
  localFile?: File;
  imageLoadFailed = false;
  @ViewChild(ImagePreviewComponent) imagePreview?: ImagePreviewComponent;

  constructor(
    private uploadService: StorageService) {}

  get imageUrl(): string {
    const selectedFileUrl = getStorageImageUrl(this.selectedFile);
    if (selectedFileUrl && !this.imageLoadFailed) {
      return selectedFileUrl;
    }
    return this.defaultImage;
  }

  get hasUploadedImage(): boolean {
    return this.hasSelectedFile && !this.imageLoadFailed;
  }

  get hasSelectedFile(): boolean {
    return Boolean(normalizeStorageImagePath(this.selectedFile));
  }

  get thumbnailActionLabel(): string {
    if (!this.enablePreview) {
      return 'Cambia immagine';
    }

    return this.hasUploadedImage ? 'Apri anteprima immagine' : 'Carica immagine';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedFile']) {
      this.imageLoadFailed = false;
    }
  }

  onImageError(): void {
    this.imageLoadFailed = true;
  }

  onImageClick(fileInput: HTMLInputElement) {
    fileInput.click();
  }

  onThumbnailClick(fileInput: HTMLInputElement): void {
    if (this.enablePreview && this.hasUploadedImage) {
      this.imagePreview?.openPreview();
      return;
    }

    this.onImageClick(fileInput);
  }

  clearImage(): void {
    this.selectedFile = null;
    this.localFile = undefined;
    this.imageLoadFailed = false;
    this.progress = 0;
    this.selectedFileChange.emit(null);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.localFile = input.files[0];
      this.imageLoadFailed = false;
      this.upload();
      input.value = '';
    }
  }

  upload(): void {
    if (!this.localFile) return;
    this.uploading = true;
    this.progress = 0;
    this.uploadService.uploadWithProgress(this.localFile, this.orgId)
      .subscribe({
        next: event => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            this.progress = Math.round(100 * event.loaded / event.total);
          } else if (event.type === HttpEventType.Response) {
            const fileName = event.body?.fileName;
            if (!fileName) {
              this.uploading = false;
              this.uploadError.emit(new Error('Upload completato senza fileName.'));
              return;
            }
            this.uploading = false;
            this.selectedFile = fileName;
            this.imageLoadFailed = false;
            this.selectedFileChange.emit(this.selectedFile);
            this.uploadSuccess.emit(fileName);
            this.localFile = undefined;
            this.progress = 0;
          }
        },
        error: err => {
          this.uploading = false;
          this.uploadError.emit(err);
        }
      });
  }
}
